import { useState, type FormEvent } from 'react'
import { useAuth } from '../auth/AuthContext'
import { Wortmarke } from '../komponenten/Wortmarke'

export function Anmeldung() {
  const { anmelden } = useAuth()
  const [email, setEmail] = useState('')
  const [passwort, setPasswort] = useState('')
  const [fehler, setFehler] = useState<string | null>(null)
  const [laeuft, setLaeuft] = useState(false)

  async function absenden(ereignis: FormEvent) {
    ereignis.preventDefault()
    setFehler(null)
    setLaeuft(true)
    try {
      await anmelden(email, passwort)
    } catch (ex) {
      setFehler(ex instanceof Error ? ex.message : 'Anmeldung fehlgeschlagen')
    } finally {
      setLaeuft(false)
    }
  }

  return (
    <div className="anmeldung">
      <div className="anmeldung-karte">
        <Wortmarke />
        <p className="anmeldung-untertitel">Multi-Tenant Bus-Operations</p>

        {fehler && <div className="meldung fehler">{fehler}</div>}

        <form onSubmit={absenden}>
          <div className="feld">
            <label htmlFor="email">E-Mail</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
              autoFocus
            />
          </div>
          <div className="feld">
            <label htmlFor="passwort">Passwort</label>
            <input
              id="passwort"
              type="password"
              value={passwort}
              onChange={(e) => setPasswort(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <button type="submit" className="knopf-primaer knopf-voll" disabled={laeuft}>
            {laeuft ? 'Anmeldung läuft …' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  )
}
